import { render, staticRenderFns } from "./concise.vue?vue&type=template&id=43f5b859&scoped=true"
import script from "./concise.vue?vue&type=script&lang=js"
export * from "./concise.vue?vue&type=script&lang=js"
import style0 from "./concise.vue?vue&type=style&index=0&id=43f5b859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f5b859",
  null
  
)

export default component.exports